import * as z from 'zod'

export const changedEmailTokenVerificationSchema = z.object({
  token: z.string().optional(),
  back_url: z.string().optional(),
})

export type TokenVerificationModel = z.infer<typeof changedEmailTokenVerificationSchema>

export const defaultTokenVerificationSchema: TokenVerificationModel = {
  token: undefined,
  back_url: undefined,
}
